export const BLACKLISTED_TAGS = {
  SCRIPT: 'script'
}
